/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DocumentsRouteImport } from './routes/documents'
import { Route as ContactsRouteImport } from './routes/contacts'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppsIndexRouteImport } from './routes/apps/index'
import { Route as DocumentsSplatRouteImport } from './routes/documents/$'
import { Route as AppsNameRouteImport } from './routes/apps/$name'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentsRoute = DocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactsRoute = ContactsRouteImport.update({
  id: '/contacts',
  path: '/contacts',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsIndexRoute = AppsIndexRouteImport.update({
  id: '/apps/',
  path: '/apps/',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentsSplatRoute = DocumentsSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => DocumentsRoute,
} as any)
const AppsNameRoute = AppsNameRouteImport.update({
  id: '/apps/$name',
  path: '/apps/$name',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/contacts': typeof ContactsRoute
  '/documents': typeof DocumentsRouteWithChildren
  '/login': typeof LoginRoute
  '/apps/$name': typeof AppsNameRoute
  '/documents/$': typeof DocumentsSplatRoute
  '/apps': typeof AppsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/contacts': typeof ContactsRoute
  '/documents': typeof DocumentsRouteWithChildren
  '/login': typeof LoginRoute
  '/apps/$name': typeof AppsNameRoute
  '/documents/$': typeof DocumentsSplatRoute
  '/apps': typeof AppsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/contacts': typeof ContactsRoute
  '/documents': typeof DocumentsRouteWithChildren
  '/login': typeof LoginRoute
  '/apps/$name': typeof AppsNameRoute
  '/documents/$': typeof DocumentsSplatRoute
  '/apps/': typeof AppsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/contacts'
    | '/documents'
    | '/login'
    | '/apps/$name'
    | '/documents/$'
    | '/apps'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/contacts'
    | '/documents'
    | '/login'
    | '/apps/$name'
    | '/documents/$'
    | '/apps'
  id:
    | '__root__'
    | '/'
    | '/contacts'
    | '/documents'
    | '/login'
    | '/apps/$name'
    | '/documents/$'
    | '/apps/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ContactsRoute: typeof ContactsRoute
  DocumentsRoute: typeof DocumentsRouteWithChildren
  LoginRoute: typeof LoginRoute
  AppsNameRoute: typeof AppsNameRoute
  AppsIndexRoute: typeof AppsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/documents': {
      id: '/documents'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof DocumentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contacts': {
      id: '/contacts'
      path: '/contacts'
      fullPath: '/contacts'
      preLoaderRoute: typeof ContactsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/': {
      id: '/apps/'
      path: '/apps'
      fullPath: '/apps'
      preLoaderRoute: typeof AppsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/documents/$': {
      id: '/documents/$'
      path: '/$'
      fullPath: '/documents/$'
      preLoaderRoute: typeof DocumentsSplatRouteImport
      parentRoute: typeof DocumentsRoute
    }
    '/apps/$name': {
      id: '/apps/$name'
      path: '/apps/$name'
      fullPath: '/apps/$name'
      preLoaderRoute: typeof AppsNameRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface DocumentsRouteChildren {
  DocumentsSplatRoute: typeof DocumentsSplatRoute
}

const DocumentsRouteChildren: DocumentsRouteChildren = {
  DocumentsSplatRoute: DocumentsSplatRoute,
}

const DocumentsRouteWithChildren = DocumentsRoute._addFileChildren(
  DocumentsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ContactsRoute: ContactsRoute,
  DocumentsRoute: DocumentsRouteWithChildren,
  LoginRoute: LoginRoute,
  AppsNameRoute: AppsNameRoute,
  AppsIndexRoute: AppsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
